import { ApolloClient, InMemoryCache } from "@apollo/client";
import { environment } from '../environments/environment';

export const client = new ApolloClient({
    uri: environment.graphqlUri,
    cache: new InMemoryCache()
});

